/* Produktkacheln (snippets/product-card-v2): "In den Warenkorb" wie auf den Kollektionsseiten.
   Ein Produkt mit einer Variante wird direkt hinzugefügt, bei mehreren öffnet sich die Variantenliste. */
(function () {
  if (window.__pcActions) return;
  window.__pcActions = true;
  var closeAll = function (except) {
    document.querySelectorAll('.product-card-variant-popup.is-open').forEach(function (p) { if (p !== except) p.classList.remove('is-open'); });
  };
  var add = function (btn, variantId) {
    var label = btn.querySelector('.pc-btn-text');
    var orig = label ? label.textContent : '';
    btn.setAttribute('disabled', 'disabled');
    if (label) label.textContent = btn.getAttribute('data-adding') || '…';
    var body = new URLSearchParams();
    body.append('form_type', 'product');
    body.append('utf8', '✓');
    body.append('id', String(variantId));
    body.append('quantity', '1');
    fetch('/cart/add', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        var ok = (cart.items || []).some(function (i) { return String(i.variant_id) === String(variantId); });
        if (ok) {
          if (cart.item_count > 0) {
            document.querySelectorAll('[data-ajax-cart-trigger]').forEach(function (t) { t.classList.add('has-cart-count'); });
            document.querySelectorAll('[data-bind="itemCount"]').forEach(function (t) { t.textContent = cart.item_count; });
          }
          if (label) label.textContent = btn.getAttribute('data-added') || orig;
          var th = window.PXUTheme && window.PXUTheme.jsAjaxCart;
          if (th) { try { th.showDrawer(); th.updateView(); } catch (e) {} }
        } else if (label) {
          label.textContent = btn.getAttribute('data-error') || orig;
        }
        setTimeout(function () { btn.removeAttribute('disabled'); if (label) label.textContent = orig; }, 1600);
      })
      .catch(function () { btn.removeAttribute('disabled'); if (label) label.textContent = orig; });
  };

  /* Herz oben rechts an der grauen Kachel ausrichten (Abstand oben ist je nach Bereich verschieden) */
  var placeHearts = function () {
    document.querySelectorAll('article.product-card').forEach(function (c) {
      var h = c.querySelector(':scope > .aico-wishlist-toggle--card'), l = c.querySelector(':scope > .product-card-link');
      if (h && l) h.style.setProperty('top', (l.offsetTop + 4) + 'px', 'important');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeHearts); else placeHearts();
  window.addEventListener('load', placeHearts);
  window.addEventListener('resize', placeHearts);
  setTimeout(placeHearts, 1500);
  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('[data-pc-variant]');
    if (opt) {
      e.preventDefault();
      var pop = opt.closest('.product-card-variant-popup');
      var btn = pop && pop.parentElement.querySelector('[data-pc-add]');
      if (pop) pop.classList.remove('is-open');
      if (btn) add(btn, opt.getAttribute('data-pc-variant'));
      return;
    }
    var b = e.target.closest && e.target.closest('[data-pc-add]');
    if (!b) { if (!(e.target.closest && e.target.closest('.product-card-variant-popup'))) closeAll(); return; }
    e.preventDefault();
    if (b.hasAttribute('disabled')) return;
    var v = b.getAttribute('data-variant-id');
    if (v) { add(b, v); return; }
    var p = b.parentElement.querySelector('.product-card-variant-popup');
    if (p) { closeAll(p); p.classList.toggle('is-open'); }
  });
})();
